import styled from "styled-components";

export const Divider = styled.div`
  background: var(--border-color);
  height: 1px;
  width: 100%;
  margin: 12px 0;
`;
